import React from 'react'
import './Header.css';
import { useNavigate } from "react-router-dom";
import logo from '../../assets/logo.gif';
const Header = ({ onLogout }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    onLogout(); 
    navigate("/"); 
  };
  return (
    <header>
      <div className='logo-out-cont'>
       <img src={logo} alt="Logo" className="header-logo" />
       </div>
       <div className='title-out-cont'>
       <h1>RAM THANGANAGAI MALIGAI</h1>
       </div>
       <div className='sign-outer-cont'>
    <button  className="sign-out-button" onClick={handleLogout}>Sign Out</button>
    </div>
  </header>
  )
}
export default Header
